var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4"},[_c('CompetitionSummaryFilters',{key:_vm.refreshKey,staticClass:"mb-4",on:{"filtersApplied":_vm.loadSummary,"refresh":_vm.refreshFilters}}),_c('CompetitionSummary',{attrs:{"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }